// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2563":"c277b0ae","3485":"70adc002","3528":"70adc002","8738":"c72b6c6f","9050":"69f51dc4"}[chunkId] + ".chunk.css";
};